import React from 'react'
import topnotch_6 from '../images/topnotch/topnotch_6'
import  staff_header_1 from '../images/topnotch/staff_header_1'
import employee_1 from '../images/employee_1'

import buisness_manage from '../images/buisness_manage'
export default function StaffOwnerTraning() {
  return <>
    <div class="page-wrapper sec-mar">
        <article
          id="post-15"
          class="post-15 page type-page status-publish hentry"
        >
          <div class="inner-post">
            <div
              data-elementor-type="wp-page"
              data-elementor-id="15"
              class="elementor elementor-15"
            >
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-7570cb6 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                data-id="7570cb6"
                data-element_type="section"
              >
                <div class="elementor-container elementor-column-gap-no">
                  <div
                    class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0751275"
                    data-id="0751275"
                    data-element_type="column"
                  >
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-96da640 elementor-widget elementor-widget-spinner_slider"
                        data-id="96da640"
                        data-element_type="widget"
                        data-widget_type="spinner_slider.default"
                      >
                        <div class="elementor-widget-container">

                          <div class="banner-section2">
                            <div class="banner2-spring1"></div>
                            <div class="banner2-spring2"></div>
                            <div class="banner2-circle1"></div>
                            <div class="banner2-circle2"></div>
                            <img
                              decoding="async"
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner2-vector.png"
                              class="banner2-vector"
                              alt="image"
                            />

                            
                            <div class="swiper banner2">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  <img
                                    decoding="async"
                                    src={ staff_header_1}
                                    // src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/Banner-Image.jpg"
                                    class="slider-bg"
                                    alt="image"
                                  />
                                  <div class="container">
                                    <div class="row d-flex justify-content-center align-items-center">
                                      <div class="col-xl-7 col-lg-10">
                                        <div class="banner2-content">
                                          <span>
                                            WE ARE TOP NOTCH MEDIA WORKS
                                          </span>
                                          <h2>STAFF AND OWNER TRANING
</h2>

                                         
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  <img
                                    decoding="async"
                                    src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner2-bg2-1.png"
                                    class="slider-bg"
                                    alt="image"
                                  />
                                  
                                </div> */}
                              </div>
                            </div>
                            <div class="banner2-pagination d-flex justify-content-center flex-row align-items-center gap-2"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>

       {/* main section */}

<div className="container">
  <div className="row text-center">
    <h1><b>STAFF AND OWNER TRANING


</b></h1>
<p>We provide training for the staff. This training includes different orientation programs.




</p>
  </div>
</div>


<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Employee Management


-</span>
                    <h3  className="text-light">
                    Employee Management


                    </h3>
                    <p class="para mb-0 ">
                    The training is provided by the best trainers for sales persons. Training your staff is an investment for your business. If they are trained with perfect skills and knowledge, it will be beneficial for your company




                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src={employee_1} alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


{/* /target Analysis */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://us.123rf.com/450wm/rawpixel/rawpixel1507/rawpixel150707516/rawpixel150707516.jpg?ver=6" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Buisness Ethics



-</span>
                    <h3  className="text-light">
                    Buisness Ethics




                    </h3>
                    <p class="para mb-0 ">
                    The success of your business depends on your ability to train the people who work for you. Without proper guidance and education, your retail employees can’t perform at the level you expect.



.</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* POC Creation */}

      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Managing Business Environment


-</span>
                    <h3  className="text-light">
                    Managing Business Environment


                    </h3>
                    <p class="para mb-0 ">
                    You must communicate effectively, and it’s your responsibility to ensure they fully understand your expectations and their role in your shop.





                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        {/* <img src={buisness_manage} alt="" /> */}
                        <img src='https://media.istockphoto.com/id/1465188429/photo/business-performance-monitoring-concept-businessman-using-smartphone-online-survey-filling.webp?b=1&s=170667a&w=0&k=20&c=QJ2XWQVsbaB3Rzjk8tXv1csVlvyDvtww1NXK8yHzNl0=' alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    
  
 
  </>
}
